export default {
    aws: {
      AWS_COMMIT_ID: '12c3109dc5c3efbbd9e798449b1e60b37cc56c1b',
    },
  };